import { render } from "./BuybackListSetup.vue?vue&type=template&id=354faf64"
import script from "./BuybackListSetup.vue?vue&type=script&lang=js"
export * from "./BuybackListSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Buyback/BuybackListSetup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "354faf64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('354faf64', __exports__)) {
    api.reload('354faf64', __exports__)
  }
  
  module.hot.accept("./BuybackListSetup.vue?vue&type=template&id=354faf64", () => {
    api.rerender('354faf64', render)
  })

}


export default __exports__